import { submitOrderToQuarry, submitOrderToNewBuying } from 'utils/api.service';
import { addNewNotification } from './notification_actions';

export const Types = {
  FETCH_OPTIONS: 'quarry/FETCHING_OPTION',
  ERROR_SETTING: 'quarry/FETCHING_ERROR',
  FETCH_META_VALS: 'quarry/FETCHING_META_VALS',
  RESET_SUCCESS: 'quarry/RESETTING_DEFAULT',
  SUBMIT_ORDER_START: 'quarry/SUBMIT_ORDER_START',
  SUBMIT_ORDER_SUCCESS: 'quarry/SUBMIT_ORDER_SUCCESS',
  SUBMIT_ORDER_FAIL: 'quarry/SUBMIT_ORDER_FAIL',
};

export const resetSuccess = () => {
  return (dispatch) => {
    dispatch({
      type: Types.RESET_SUCCESS,
      sending: false,
      message: '',
      status: '',
    });
  };
};

export const submitOrder = (payload, version, channel) => {
  return (dispatch) => {
    const customEndpoints = [
      'return',
      'addseat',
      'addproduct',
      'renewal',
      'pws_addproduct',
      'pws_addseat',
      'aoe_addproduct',
      'aoe_addseat',
      'reference',
    ];
    let endpointChannel = channel;

    dispatch({ type: 'MESH_CLEAR_TESTCASES' });
    dispatch({ type: 'HOSTING_RESET' });
    dispatch({ type: Types.SUBMIT_ORDER_START });

    if (customEndpoints.includes(payload.ordertype)) {
      endpointChannel = payload.ordertype.replace('_', '');
    }

    let response = null;
    if (payload.isNXM === true || payload.isNXM === 'true') {
      response = submitOrderToNewBuying(payload, version, endpointChannel);
    } else {
      response = submitOrderToQuarry(payload, version, endpointChannel);
    }

    response
      .then((response) => {
        dispatch({
          type: Types.SUBMIT_ORDER_SUCCESS,
          status: response.status,
          data: response.data,
        });
        dispatch(
          addNewNotification('Order submitted successfully', 'success', {
            to: '/jobsqueue',
            text: 'Go to Jobs Queue',
          })
        );
      })
      .catch((error) => {
        const errorMessage = error.response
          ? error.response.data.detail
          : error.message;
        dispatch({
          type: Types.SUBMIT_ORDER_FAIL,
          status: error.response?.status,
          error: errorMessage,
        });
        dispatch(addNewNotification(errorMessage, 'danger'));
      });
  };
};
